<div class="d-flex justify-content-center">
  <mat-progress-spinner color="primary" mode="indeterminate" [diameter]="60"></mat-progress-spinner>
</div>
